import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet, View } from 'react-native';
import { Popover } from '@headlessui/react';
import { theme } from '@xbto/design-system';
import { Col } from '../../atoms';
import { useState } from 'react';
// Note: TODO for later, we use react-popper here coz of using an older version of popper. We can move to floating/ui instead of popper if we upgrade headless/ui
import { usePopper } from 'react-popper';
import { createPortal } from 'react-dom';
export default function PopoverWeb({ children, trigger, placement, maxWidth, }) {
    /**
     * State
     */
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState();
    const handleEnter = isOpen => {
        if (!isOpen)
            referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.click();
    };
    const handleLeave = isOpen => {
        if (isOpen)
            referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.click();
    };
    /**
     * Hooks
     */
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement,
        strategy: 'fixed',
    });
    /**
     * DOM
     */
    return (_jsx(Popover, { children: ({ open }) => (_jsxs(View
        // @ts-expect-error This is web only
        , { 
            // @ts-expect-error This is web only
            onMouseEnter: () => handleEnter(open), onMouseLeave: () => handleLeave(open), children: [_jsx(Popover.Button, { ref: setReferenceElement, style: {
                        appearance: 'none',
                        border: 'none',
                        outline: 'none',
                        backgroundColor: 'transparent',
                        padding: 0,
                        paddingBlock: 0,
                    }, children: trigger }), createPortal(_jsx(Popover.Panel, Object.assign({ ref: setPopperElement, style: Object.assign(Object.assign({}, styles.popper), { maxWidth }) }, attributes.popper, { children: _jsx(Col, { p: "2", style: $.itemsContainer, children: children }) })), document.body)] })) }));
}
const $ = StyleSheet.create({
    // TODO(Benoit): use DropdownContainer
    itemsContainer: {
        marginTop: theme.spacing['1'],
        borderWidth: 1,
        borderColor: theme.color.border.primary,
        borderRadius: theme.radius.sm,
        backgroundColor: theme.color.background.white,
        maxHeight: 240,
        // @ts-expect-error setting web specific styles
        overflow: 'auto',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.05,
        shadowRadius: 3.84,
        elevation: 5,
    },
});
